import { render } from "./PaymentForm.vue?vue&type=template&id=03279eca&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=ts"
export * from "./PaymentForm.vue?vue&type=script&lang=ts"

import "./PaymentForm.vue?vue&type=style&index=0&id=03279eca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03279eca"

export default script